import IcOpenList from '@/assets/svg/ic-open-list.svg?inline'

export default {
  name: 'PageDropdown',
  props: {
    isOpened: {
      type: Boolean,
      default: true
    },
    /**
     * все отступы должны быть в вышестоящем компоненте
     */
     notAnimation: {
      type: Boolean,
      default: false,
    },
    /**Вычисляемые стили */
    // если не аккордеон
    isEqualShares: {
      type: Boolean,
      default: false
    },
    isLastInList: {
      type: Boolean,
      default: false
    },
    headerHeight: {
      type: Number,
      default: 68
    },
    margin: {
      type: Number,
      default: 10
    },
    countInColumn: {
      type: Number,
      default: 1
    }
    /**Конец Вычисляемые стили */
  },
  components: {
    IcOpenList
  },
  data() {
    return {
      open: true
    }
  },
  computed: {
    dropdownStyle() {
      if (this.notAnimation) {
        return
      }
      const result = {}
      if (!this.isLastInList) {
        result['margin-bottom'] = `${this.margin}px`
      }
      if (this.open) {
        let maxHeigth = ''
        if (this.isEqualShares) {
          maxHeigth = `calc(${100 / this.countInColumn}% - ${(this.margin * (this.countInColumn - 1)) / this.countInColumn}px)`
        } else {
          maxHeigth = `calc(100% - ${(this.headerHeight + this.margin) * (this.countInColumn - 1)}px)`
        }
        result.height = '100%'
        result['max-height'] = maxHeigth
        result['min-height'] = `${this.headerHeight}px`
      } else {
        result.height = `${this.headerHeight}px`
        result['max-height'] = `${this.headerHeight}px`
      }
      return result
    },
    contentStyle() {
      const result = {}
      if (this.notAnimation) {
        return result
      }
      if (this.open) {
        const heightCss = `calc(100% - ${this.headerHeight}px)`
        result['max-height'] = heightCss
        result.height = heightCss
      } else {
        result['max-height'] = 0
        result.height = 0
      }
      return result
    }
  },
  methods: {
    openDropdown() {
      this.open = true
      this.$emit('toggle', this.open)
    },
    closeDropdown() {
      this.open = false
      this.$emit('toggle', this.open)
    },
    toggle() {
      if (this.open) {
        this.closeDropdown()
      } else {
        this.openDropdown()
      }
    }
  },
  watch: {
    isOpened: {
      immediate: true,
      handler() {
        this.open = this.isOpened
      }
    }
  }
}